<template>
<!-- :height="tableHeight" -->
   <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :selection="true"
      :rowHeight="100"
      height="420px"
      @selection-change="selectedChange"
    >
      <template slot="mainImagesSlot" slot-scope="{ row }">
        <div style="display: flex; align-items: center">
          <ListLazyImg :src="`${row.mainImages[0]}`" />
        </div>
      </template>
      <template slot="titleSlot" slot-scope="{ row }">
        <el-tooltip effect="dark" :content="row.title" placement="top">
          <span class="line-ellipsis">{{ row.title }}</span>
        </el-tooltip>
      </template>
    </TableList>
</template>

<script>
import TableList from "@/components/ColsTable/index.vue";
import ListLazyImg from '@/components/ListLazyImg/index.vue';
import StatusBtn from "@/components/prod/center/components/StatusBtn.vue";
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  data() {
    return {
       cols: [
        {prop: "mainImages",attrs: { label: "图片", width: "90px" },slot: true,},
        {prop: "outerId", attrs: { label: "款式编码", width: "260px", 'class-name': 'outerId-cell', 'show-overflow-tooltip': true } },
        {prop: "title",attrs: {label: "商品名称",width: "180px", "show-overflow-tooltip": true,},slot: true,},
        {prop: "salesPrice", attrs: { label: "销售价" } },
        {prop: "marketPrice", attrs: { label: "市场价" } },
        {prop: "stock", attrs: { label: "库存" } },
        {prop: "createSource", attrs: { label: "商品来源" }},
        {prop: "supplierName", attrs: { label: "线下供销商" }},
        {prop: "updateTime", attrs: { label: "更新时间" }},
        {prop: "createName", attrs: { label: "创建人" }},
        {prop: "createTime", attrs: { label: "创建时间", width:'200px'}},
      ],
      selectedArr: []
    }
  },
  components: {
    TableList,
    ListLazyImg,
    StatusBtn
  },
  methods: {
    selectedChange(val) {
      this.selectedArr = val;
    },
    method_getSelectedArr() {
      return this.selectedArr.length > 0 ? this.selectedArr : false;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
